import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { mailboxService, mailboxErrorMessage } from '../services/mailbox.service';

/**
 * Where Google sends the user back after they approve (or refuse) connecting Gmail. Completes the connection, then
 * returns to Connected Services. The state and code in the address are single use, so this only runs once even if React
 * renders the page twice.
 */
const MailboxCallbackPage = () => {
  const navigate = useNavigate();
  const [message, setMessage] = useState('Connecting your Gmail account…');
  const [error, setError] = useState(null);
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;

    const params = new URLSearchParams(window.location.search);
    if (params.get('error')) {
      setError('Gmail was not connected. You can try again from Connected Services whenever you like.');
      return;
    }
    const code = params.get('code');
    const state = params.get('state');
    if (!code || !state) {
      setError('This connection link is not valid. Please start again from Connected Services.');
      return;
    }

    (async () => {
      try {
        await mailboxService.complete(state, code);
        setMessage('Gmail connected. Taking you back…');
        setTimeout(() => navigate('/connected-services'), 1500);
      } catch (err) {
        setError(mailboxErrorMessage(err));
      }
    })();
  }, [navigate]);

  return (
    <div className="cs-page" style={{ padding: '48px 24px', textAlign: 'center' }}>
      {error ? (
        <>
          <p role="alert">{error}</p>
          <button type="button" className="cs-btn cs-btn-primary" onClick={() => navigate('/connected-services')}>Back to Connected Services</button>
        </>
      ) : (
        <p>{message}</p>
      )}
    </div>
  );
};

export default MailboxCallbackPage;
